export default __webpack_public_path__ + "static/Punk-520ca7d3cbcd19e58805ec038ea46a75.png";